import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);
dayjs.extend(utc);

export const isDate = (input: any): boolean => {
  // Check if the input is a Date object
  if (input instanceof Date) {
    return true;
  }

  // Check if the input is a string that can be parsed as a date by dayjs
  if (typeof input === 'string' && dayjs(input).isValid()) {
    return true;
  }

  return false;
}

export const DateToStringFormat = (date: string) => {
  return dayjs.utc(date).format("MM/DD/YYYY");
};

export const dateToTimeFormat = (date: any) => {
  if (!isDate(date)) {
    return null;
  }
  try {
    return dayjs.utc(date).format("ddd DD MMM YYYY HH:mm:ss");
  } catch {
    return null;
  }
};

export const date_MMM_Do_YYYY_Format = (date: any) => {
  if (!isDate(date)) {
    return null;
  }
  try {
    return dayjs.utc(date).format("MMM Do YYYY");
  } catch {
    return null;
  }
};

export const date_YYYY_MM_DD_hh_mm_format = (date: any) => {
  if (!isDate(date)) {
    return null;
  }
  try {
    return dayjs.utc(date).format("YYYY-MM-DD HH:mm");
  } catch {
    return null;
  }
}

export const approximatedTimePasted = (date: any) => {
  if (!isDate(date)) {
    return null;
  }
  try {
    const pastedDate = dayjs.utc(date);
    const today = dayjs.utc();

    const dayDiff = today.diff(pastedDate, "day");

    if (dayDiff < 7) {
      return `${dayDiff} days ago`;
    } else if (dayDiff >= 7 && dayDiff < 31) {
      const weekDiff = Math.floor(dayDiff / 7);
      if (weekDiff === 1) return `approximately ${weekDiff} week ago`;
      return `approximately ${weekDiff} weeks ago`;
    } else if (dayDiff < 730) {
      const monthDiff = today.diff(pastedDate, "month");
      if (monthDiff === 1) return `approximately ${monthDiff} month ago`;
      return `approximately ${monthDiff} months ago`;
    } else {
      const yearDiff = today.diff(pastedDate, "year");
      return `over ${yearDiff} years ago`;
    }
  } catch {
    return null;
  }
};

export const getFormatedDayhour = (time: any) => {
  try {
    return dayjs(time).format("HH:mm a");
  } catch {
    return null
  }
}
